var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',[_c('br'),_vm._v(" "),_c('h3',[_vm._v("JSON STRUCTURE INSIDE FIREBASE")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.database))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad4cb046","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View.vue
// module id = 3URI
// module chunks = 1